export const redirectTo = (local: string) => {
  window.location.href = local
}